import { Box } from '@mui/system';
import React, { useCallback, useMemo } from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import AppProfileIcon from 'src/components/BeaconV2Components/Header/AppProfileIcon';
import moment from 'moment';
import { StacklineDefaultProfileImage } from 'src/components/SvgIcons';

const TopicOwner = ({
  userId,
  firstName = 'Stackline',
  lastName = 'Support',
  createdAt
}: {
  userId: string;
  firstName: string;
  lastName: string;
  createdAt: string;
}) => {
  const name = useMemo(() => `${firstName} ${lastName}`, [firstName, lastName]);
  const initials = useMemo(() => `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`, [firstName, lastName]);

  const renderIcon = useCallback(() => {
    if (userId && firstName && lastName) {
      return <AppProfileIcon userId={userId} initials={initials} />;
    }
    return <StacklineDefaultProfileImage style={{ width: '30px', height: '30px' }} />;
  }, [firstName, lastName, userId, initials]);

  return (
    <Box display="flex" gap="12px" alignItems="center" sx={{ width: '100%', height: '37px' }}>
      {renderIcon()}
      <Flex flexDirection="column" gap={1}>
        <Flex alignItems="center" height="19px">
          <Text
            sx={{ maxWidth: '170px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'noWrap' }}
            variant="body2"
          >
            {name}
          </Text>
        </Flex>
        <Flex alignItems="center" height="16px">
          <Text color="secondary" variant="body3">
            {moment(createdAt).format('MMM D, YYYY')}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default TopicOwner;
